import pptxgen from 'pptxgenjs'

import { OPEN_SANS_REGULAR } from '../common/constants'
import { SLIDE_SIZE_PX, percentageToInches, getCoordinates, decodeHtml } from '../helpers'

const pptx = new pptxgen()

function renderBarChart({ x, y, height, width, parent, svgNode, slide }) {
  const coordinates = getCoordinates({ x, y }, parent)

  const xOffset = (width / 100) * 8
  const yOffset = (height / 100) * 24
  // Divide offset by two to center
  const translateY = percentageToInches(yOffset / 2 / 1080, 'y')
  const translateX = percentageToInches(xOffset / 2 / 1920, 'x')

  const chartPosition = {
    x: coordinates.x + translateX,
    y: coordinates.y + (height > 300 && translateY),
    h: percentageToInches((height - yOffset) / SLIDE_SIZE_PX.y, 'y'),
    w: percentageToInches((width - xOffset) / SLIDE_SIZE_PX.x, 'x'),
  }

  const data = svgNode.properties['data-json']
  const decodedData = JSON.parse(decodeHtml(data))

  const exportOptionsRaw = svgNode.properties['data-export-options']
  const { valueType = 'percent' } = exportOptionsRaw ? JSON.parse(decodeHtml(exportOptionsRaw)) : {}

  const dataChartBarStat = [
    {
      name: '',
      labels: decodedData.map(({ key }) => key).reverse(),
      values: decodedData.map(({ value }) => value).reverse(),
    },
  ]

  const dataLabelFormatter = {
    percent: '#%',
    overIndex: '#0.0#x',
  }

  const optsChartBar = {
    ...chartPosition,
    layout: {
      x: 0,
      y: 0,
      w: 1,
      h: 1,
    },

    barDir: 'bar',
    axisLineColor: 'ebebeb',
    catAxisLabelFontSize: 7,
    catAxisLabelColor: '717171',
    catAxisLabelFontFace: OPEN_SANS_REGULAR,
    valAxisLineShow: false,
    valAxisHidden: true,
    valAxisMinVal: 0,
    showValue: true,
    dataLabelPosition: 'ctr',
    dataLabelFormatCode: dataLabelFormatter[valueType],
    dataLabelColor: 'ffffff',
    dataLabelFontSize: 7,
    chartColors: ['146A59'],
    barGapWidthPct: 50,
    valGridLine: {
      style: 'none',
    },

    //title
    title: '',
    showTitle: false,
  }

  slide.addChart(pptx.ChartType.bar, dataChartBarStat, optsChartBar)
}

export default renderBarChart
